var _style, _g, _g2, _g3, _g4, _g5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLukeLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0lsl{fill:#588443;}\r\n\t.st1lsl{fill:#4C7085;}\r\n\t.st2lsl{fill:#FAC8AA;}\r\n\t.st3lsl{fill:#F9C2A0;}\r\n\t.st4lsl{fill:#43657F;}\r\n\t.st5lsl{fill:#72787C;}\r\n\t.st6lsl{fill:#838B91;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lag_1_1_"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0lsl",
    cx: 150,
    cy: 150.3,
    r: 150
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Lag_5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1lsl",
    d: "M60.8,186.6c1.2,24.7,2.4,49.3,3.6,74c58.6,0,117.3,0,175.9,0c2.4-27.3,4.8-54.5,7.2-81.8 C185.2,181.4,123,184,60.8,186.6z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Lag_2_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2lsl",
    d: "M89.5,73.4c-11,24.7-22,49.4-33,74.1c-2,7.1-7.4,29.5,4.7,43.2c0.9,1,1.9,2,3.1,3c2.7,0.7,5.5,1.4,8.2,2.2 c5.2,13.2,10.4,26.3,15.7,39.5c21,10.7,41.9,21.5,62.9,32.2V70.9C130.5,71.7,110,72.5,89.5,73.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3lsl",
    d: "M242.7,146.5c-12.7-26-25.4-51.9-38.2-77.9c-18.5,0.7-37,1.5-55.5,2.2v196.7c20.8-10.3,41.6-20.7,62.4-31 c3.8-6.5,7.5-13.1,11.3-19.6c1.7-6.5,3.4-13,5.2-19.5c3.9-0.6,6.6-1.9,8.6-3.3C247,186.6,249.4,167.6,242.7,146.5z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Lag_3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4lsl",
    d: "M62.4,227.7C74,184.9,85.5,142.1,97.1,99.4c6.8-4.7,25.2-15.9,51.3-16.2c27.1-0.2,46.2,11.6,53,16.2 c13.9,42.8,27.9,85.6,41.8,128.3c14.5-75.7-3-146-49.7-179.8c-9.8-7.1-23.9-14.8-43.5-19c-26.3,4.2-43.2,14.7-52.8,22.4 C53.7,86.1,40.2,156,62.4,227.7z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Lag_4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5lsl",
    d: "M149.8,233.7c-20-0.3-35.2-3.3-39.6-4.3c-7.6-1.7-17.2-4.5-28-9c0.7,4.1,2.2,10,5.5,16.4 c6,11.8,14.4,18.2,18.1,21c18.2,13.8,37.7,13.5,44.3,13.3c0.3,0,0.6,0,0.9,0v-37.3C150.6,233.7,150.2,233.7,149.8,233.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6lsl",
    d: "M149,233.7V271c7.7-0.3,21.3-1.9,35.7-9.9c22.6-12.5,32.2-32.4,35.2-39.3c-8.7,3.1-18.9,6.1-30.5,8.3 C174,233,160.3,233.8,149,233.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5lsl",
    d: "M90.3,225c0.8,3.8,23.4-8.8,60.7-8.2v-19.6C117.2,196.7,89.4,220.6,90.3,225z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6lsl",
    d: "M149.2,197.2c-0.1,0-0.1,0-0.2,0v19.6c1.1,0,2.2,0,3.3,0.1c35.6,1.3,56.5,13.9,57.3,10.3 C210.7,222.9,183,197.8,149.2,197.2z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLukeLogo);
export default __webpack_public_path__ + "static/media/luke-logo.cb08ef55.svg";
export { ForwardRef as ReactComponent };